import Selector from "../components/Selector";
import "./TransportSimulation.css";
import { useState } from "react";
//import CustomTable from "../components/Table";

//TODO : DO NOT NEED CUSTOM TABLE?
// import TransportData from "../files/Στοιχεία Πληροφόρησης.json"
// import ConnectedData from "../files/Συνδυασμένη Μετακίνηση.json"
import TransportData from "../backend-files/helpers/data/Στοιχεία Πληροφόρησης final.json";
import ConnectedData from "../backend-files/helpers/data/Συνδυασμένη Μετακίνηση.json";
import DirectTransport from "../backend-files/helpers/data/Απευθείας Μετακίνηση.json";

import LinksTable from "../components/LinksTable";
import ExtremeTable from "../components/ExtremeCaseTable";

import ConnectedDestinationMeans from "../components/ConnectedTransportDestSelector.js";
import ConnectedStartMeans from "../components/ConnectedTransportStartSelector.js";

export default function RoadTransport() {
  // console.log("MainPage");

  // console.log("Απευθείας",DirectTransport)
  // console.log("Στοιχεια",TransportData)
  // console.log("Συνδυασμενη",ConnectedData)

  // UseState hook in order to grab the value from child component Selector
  //Start
  const [startSelectorValue, setstartSelectorValue] = useState("");

  //End
  const [endSelectorValue, setendtSelectorValue] = useState("");

  //Connected Transport
  const [connectedSelectorValue, setconnectedSelectorValue] = useState("");

  //Means of Transport state
  const [MeansOfTransport, setMeansOfTransport] = useState("");

  // State and function for Connected Transport Button
  const [ConnectedTransportButton, setConnectedTransportButton] =
    useState(false);

  // State for signal when there is no data for connected transport
  const [NoConnectedRootFlag, setNoConnectedRootFlag] = useState(false);

  const [ConnectedStartMeansValue, setConnectedStartMeansValue] = useState("");

  const [ConnectedDestMeansValue, setConnectedDestMeansValue] = useState("");

  //Grab values of cities for dropdowns
  var temp = [];
  for (var k = 0; k < Object.keys(DirectTransport).length; k++) {
    temp.push(DirectTransport[k]["Προέλευση"]);
  }

  //remove duplicates by converting list to set
  const unique_list = [...new Set(temp)];

  //Convert Data into a list
  const dataTable = [];
  for (var i = 0; i < Object.keys(TransportData).length; i++) {
    dataTable.push(TransportData[i]);
  }

  // Convert Data for Connected Transports into a list
  const ConnectedTransportData = [];
  for (var j = 0; j < Object.keys(ConnectedData).length; j++) {
    ConnectedTransportData.push(ConnectedData[j]);
  }

  //Map value and label in order to ger different key values
  let SelectionsData = unique_list.map((x) => ({ value: x, label: x }));

  // Data for Start and Destination Selectors
  const startSelector = {
    title: "Εκκίνηση",
    defaultText: "Επιλογή από τη λίστα",
    options: SelectionsData,
  };

  const destinationSelector = {
    title: "Προορισμός",
    defaultText: "Επιλογή από τη λίστα",
    options: SelectionsData,
  };

  //function for removing duplicate values of list
  function removeDuplicates(array, field) {
    const uniqueValues = array.reduce((acc, current) => {
      acc[current[field]] = current;
      return acc;
    }, {});
    return Object.values(uniqueValues);
  }

  //Grab ConnectedSelectorValues
  function ConnectedSelector() {
    if (ConnectedTransportButton) {
      //grab the intermediate destination values for selector
      let newData = ConnectedTransportData.filter(function (obj) {
        return (
          obj["Προέλευση"] === startSelectorValue &&
          obj["Προορισμός"] === endSelectorValue
        );
      });

      newData = removeDuplicates(newData, "Ενδιάμεσος Προορισμός");

      let SelectorData = newData.map((obj, i) => {
        return obj["Ενδιάμεσος Προορισμός"];
      });

      let FinSelectorData = SelectorData.map((x) => ({ value: x, label: x }));

      let ConnectionSelector = {
        title: "Ενδιάμεσος Προορισμός",
        defaultText: "Επιλογή από τη λίστα",
        options: FinSelectorData,
      };
      if (FinSelectorData.length !== 0) {
        return (
          <Selector
            props={ConnectionSelector}
            onSelect={setconnectedSelectorValue}
          />
        );
      } else {
        setNoConnectedRootFlag(true);
        return <></>;
      }
    }
  }

  //Condition if both selectors got a value -> Search for data
  let SelectionResult = [];
  if (startSelectorValue !== "" && endSelectorValue !== "") {
    SelectionResult = dataTable.filter(function (obj) {
      return (
        obj["Προέλευση"] === startSelectorValue &&
        obj["Προορισμός"] === endSelectorValue
      );
    });
  }

  //--------------------------------------------------CONNECTED TRANSPORT--------------------------------------

  function onClick() {
    setConnectedTransportButton(true);
  }

  function ConnectedTransportTable({ data }) {
    if (
      data &&
      connectedSelectorValue !== "" &&
      ConnectedStartMeansValue !== ""
    ) {
      let newData = data.filter(function (obj) {
        return (
          obj["Προέλευση"] === startSelectorValue &&
          obj["Προορισμός"] === connectedSelectorValue &&
          obj["Μέσο Μετακίνησης προς Προορισμό"][0] === ConnectedStartMeansValue
        );
      });

      let newData2 = [];
      if (ConnectedDestMeansValue !== "") {
        newData2 = data.filter(function (obj) {
          return (
            obj["Προέλευση"] === connectedSelectorValue &&
            obj["Προορισμός"] === endSelectorValue &&
            obj["Μέσο Μετακίνησης προς Προορισμό"][0] ===
              ConnectedDestMeansValue
          );
        });
      }

      let temp = [...newData, ...newData2];
      console.log("extreme")
      return (
        <div>
          <div id="SelectionsTable">
            <ExtremeTable data={temp} />
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  }

  //------------------------------------- Selector for Means of Transport--------------------------
  function SelectMeansOfTransport({ data }) {
    let SelectorData = data.map((obj, i) => {
      return obj["Μέσο Μετακίνησης προς Προορισμό"][0];
    });

    let FinSelectorData = SelectorData.map((x) => ({ value: x, label: x }));

    let TransportSelector = {
      title: "Επιλέξτε Μέσο",
      defaultText: "Επιλογή από τη λίστα",
      options: FinSelectorData,
    };

    // Maybe need it
    // ResetFlag = {setConnectedTransportButton}

    return (
      <Selector props={TransportSelector} onSelect={setMeansOfTransport} />
    );
  }

  //------------------------------------------- RESULTS TABLE----------------------------------
  function FullTable({ data }) {
    if (data) {
      let newData = data.filter(function (obj) {
        return (
          obj["Προέλευση"] === startSelectorValue &&
          obj["Προορισμός"] === endSelectorValue &&
          obj["Μέσο Μετακίνησης προς Προορισμό"][0] === MeansOfTransport
        );
      });

      // if(newData.length !== 0) {
      //Check if there is link or need Connected travel
      if (newData[0]["Πληροφορίες στο χρήστη"].length < 100) {
        console.log("Links")
        return (
          <div>
            <div id="SelectionsTable">
              <LinksTable data={newData} />
            </div>

            <div id="Connected-Transport-text">
              <p>
                Αν δεν βρείτε μετάβαση που να σας βολεύει πιέστε{" "}
                <a className="button-like-text" role="button" onClick={onClick}>
                  ΕΔΩ
                </a>{" "}
                για να δοκιμάσετε μετάβαση με ενδιάμεσο προορισμό.
              </p>
            </div>
          </div>
        );
      } else {
        return (
          <div id="Connected-Transport-text">
            <p>
              Δεν υπάρχει απευθείας μετάβαση{" "}
              <a className="button-like-text" role="button" onClick={onClick}>
                ΕΔΩ
              </a>{" "}
              για να δοκιμάσετε μετάβαση με ενδιάμεσο προορισμό.
            </p>
          </div>
        );
      }
    } else {
      return <></>;
    }
  }

  const ResetObject = {
    ResetConnectedStartMeansValue: setConnectedStartMeansValue,
    ResetConnectedDestMeansValue: setConnectedDestMeansValue,
    ResetMeansFlag: setMeansOfTransport,
    ResetConnectedButton: setConnectedTransportButton,
    ResetNoRootFlag: setNoConnectedRootFlag,
    ResetConnectedSelector: setconnectedSelectorValue,
  };

  return (
    <div>
      {/* Selectors for each case */}
      <div className="container" id="SelectorsContainer">
        <Selector
          props={startSelector}
          onSelect={setstartSelectorValue}
          Reset={ResetObject}
        />
        <Selector
          props={destinationSelector}
          onSelect={setendtSelectorValue}
          Reset={ResetObject}
        />
        {startSelectorValue !== "" &&
        endSelectorValue !== "" &&
        ConnectedTransportButton === false ? (
          <SelectMeansOfTransport
            data={SelectionResult}
          ></SelectMeansOfTransport>
        ) : (
          <></>
        )}

        {ConnectedTransportButton === true ? (
          <div className="ConnectedCaseDiv new">
            <ConnectedSelector></ConnectedSelector>
            {connectedSelectorValue !== "" ? (
              <div className="ConnectedCaseDiv new">
                <ConnectedStartMeans
                  data={dataTable}
                  Start={startSelectorValue}
                  Destination={connectedSelectorValue}
                  passData={setConnectedStartMeansValue}
                ></ConnectedStartMeans>
                <ConnectedDestinationMeans
                  data={dataTable}
                  Start={connectedSelectorValue}
                  Destination={endSelectorValue}
                  passData={setConnectedDestMeansValue}
                ></ConnectedDestinationMeans>
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>

      {/* If ALL values are selected and there is a destination --> Show list */}
      {startSelectorValue !== "" &&
      endSelectorValue !== "" &&
      MeansOfTransport !== "" &&
      ConnectedTransportButton === false ? (
        SelectionResult.length !== 0 ? (
          <FullTable data={SelectionResult}> </FullTable>
        ) : (
          <></>
        )
      ) : (
        // Todo : HERE SHOULD BE DISPLAYED THE MESSAGE IF THERE IS NO IMMEDIATE TRANSPORT
        <></>
      )}

      {ConnectedTransportButton === true && NoConnectedRootFlag === false ? (
        <ConnectedTransportTable data={dataTable}> </ConnectedTransportTable>
      ) : NoConnectedRootFlag === true ? (
        <h5 style={{ marginLeft: "20%" }}>
          Δεν υπάρχει διαδρομή με ενδιάμεση σύνδεση.{" "}
        </h5>
      ) : (
        <></>
      )}
    </div>
  );
}
